import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

export const fetchMakesStarted = createAction('vehicleLink/fetchMakesStarted');
export const fetchMakesSucceeded = createAction(
  'vehicleLink/fetchMakesSucceeded'
);
export const fetchMakesFailed = createAction('vehicleLink/fetchMakesFailed');
export const setMakes = createAction('vehicleLink/setMakes');

export const fetchMakes = (code) => (dispatch, getState) => {
  const existingMakes = getState().vehicleLink.makes[code];

  if (existingMakes) {
    return existingMakes;
  }

  dispatch(fetchMakesStarted());

  return EcomEngineAPI.vehicleLink
    .makes(code)
    .then((makes) => {
      dispatch(fetchMakesSucceeded());
      dispatch(setMakes({ code, makes }));
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchMakesFailed(error.message));
    });
};
